// FILE: src/services/ai.js (FULLY UPDATED)

import axiosServices from "./axios";
import { fetchAssets } from '../store/Slices/librarySlice'; // <-- NEW IMPORT
import { store } from '../store'; // <-- NEW IMPORT to access dispatch

/**
 * Calls the backend to generate a complete social media post (image + caption).
 * @param {object} payload - The form data from the generation modal.
 * @returns {Promise<Array<object>>} - A promise that resolves to an array of post objects [{ caption, imageUrls, platform }].
 */
export const generateSocialPostService = async (payload) => {
    try {
        const response = await axiosServices.post('/api/generate-social-post', payload);
        
        // --- START: NEW LOGIC ---
        // After successful generation and saving, refresh the library data
        const { groups } = store.getState().groups;
        const groupId = groups.find(g => g.name === payload.groupName)?._id;
        if (groupId) {
            store.dispatch(fetchAssets(groupId));
        }
        // --- END: NEW LOGIC ---
        
        return response.data.posts || [];
    } catch (error) {
        console.error("Error calling generate social post service:", error);
        if (error.response?.status === 403 && error.response?.data?.errorType === 'LIMIT_REACHED') {
            const limitError = new Error(error.response.data.error);
            limitError.isLimitError = true;
            limitError.feature = 'AI Social Post Generation';
            throw limitError;
        }
        throw new Error(error.response?.data?.error || "Failed to generate post.");
    }
};

/**
 * Calls the backend to generate AI images.
 * @param {object} payload - The data for image generation (prompt, n, etc.).
 * @returns {Promise<Array<string>>} - A promise that resolves to an array of image URLs.
 */
export const generateImageService = async (payload) => {
    try {
        const response = await axiosServices.post('/api/generate-image', payload);
        
        // --- START: NEW LOGIC ---
        // After successful generation and saving, refresh the library data
        const { groups } = store.getState().groups;
        const groupId = groups.find(g => g.name === payload.group_name)?._id;
        if (groupId) {
            store.dispatch(fetchAssets(groupId));
        }
        // --- END: NEW LOGIC ---

        return response.data.images || [];
    } catch (error) {
        console.error("Error calling generate image service:", error);
        if (error.response?.status === 403 && error.response?.data?.errorType === 'LIMIT_REACHED') {
            const limitError = new Error(error.response.data.error);
            limitError.isLimitError = true;
            limitError.feature = 'AI Image Generation';
            throw limitError;
        }
        throw new Error(error.response?.data?.error || "Failed to generate images.");
    }
};

/**
 * Calls the backend to generate AI captions.
 * @param {object} payload - The data for caption generation.
 * @returns {Promise<Array<object>>} - A promise that resolves to an array of caption objects.
 */
export const generateCaptionService = async (payload) => {
    try {
        const response = await axiosServices.post('/api/generate-caption', payload);
        return response.data.captions || [];
    } catch (error) {
        console.error("Error calling generate caption service:", error);
        if (error.response?.status === 403 && error.response?.data?.errorType === 'LIMIT_REACHED') {
            const limitError = new Error(error.response.data.error);
            limitError.isLimitError = true;
            limitError.feature = 'AI Caption Generation';
            throw limitError;
        }
        throw new Error(error.response?.data?.error || "Failed to generate captions.");
    }
};